import moment from 'moment';
import { filedNames } from './constants';
import { stateToHTML } from 'draft-js-export-html';
import { typeIds } from '../../constants/common';
export { linkify } from '../../../../helpers/linkify';

export const parseFormValuesFromHTML = (htmlString) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');

  return {
    inn: doc.getElementById('custom-field-inn')?.textContent.trim() || '',
    name: doc.getElementById('custom-field-name')?.textContent.trim() || '',
    erid: doc.getElementById('custom-field-erid')?.textContent.trim() || '',
  };
};

const clesrBlockByInn = (htmlString) => {
  const temp = document.createElement('div');
  temp.innerHTML = htmlString;

  const blockToRemove = temp.querySelector('#custom-fields-container-inn');
  if (blockToRemove) {
    blockToRemove.remove();
  }

  return temp.innerHTML;
};

export const createInitialValues = (data) => {
  const datePub = data?.datePub || moment().format('YYYY-MM-DD 00:00');
  const dateEnd = data?.dateEnd || moment(datePub).format('YYYY-MM-DD 24:00');

  const isAdvertisement = data?.type?.id === typeIds.advertisement;

  const extraFields = isAdvertisement
    ? parseFormValuesFromHTML(data?.text)
    : {};

  return {
    [filedNames.typeId]: data?.type?.id || 2,
    [filedNames.dateTime]: [datePub, dateEnd].map((dateStr) => moment(dateStr)),
    [filedNames.title]: data?.title || '',
    [filedNames.text]: isAdvertisement
      ? clesrBlockByInn(data?.text)
      : data?.text || '',
    ...extraFields,
  };
};

export const parseContent = (formValues, text) => {
  const htmlContent = text
    .replace(/<p><br\s*\/?><\/p>/gi, '<!--EMPTY_LINE-->')
    .replace(/<p>\s*<\/p>/gi, '<!--EMPTY_LINE-->')
    .replace(/<div><br\s*\/?><\/div>/gi, '<!--EMPTY_LINE-->')
    .replace(/<div>\s*<\/div>/gi, '<!--EMPTY_LINE-->')
    .replace(/\n/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/>\s+</g, '><')
    .replace(/\s{2,}/g, ' ')
    .replace(/\s*style="[^"]*"/g, '')
    .replace(/<!--EMPTY_LINE-->/g, '<p style="margin:0 0 5px 0;">&nbsp;</p>')
    .replace(/<p>/g, '<p style="margin:0 0 5px 0;">')
    .replace(/<ul>/g, '<ul style="margin: 5px 0 10px 20px;padding:0;">')
    .replace(/<ol>/g, '<ol style="margin: 5px 0 10px 25px;padding:0;">')
    .replace(/<li>/g, '<li style="margin:0;padding:0;">')
    .replace(/<a([^>]+)>/g, '<a$1 target="_blank">')
    .trim();

  const additionalFields =
    formValues?.typeId === typeIds.advertisement
      ? `
        <div id="custom-fields-container-inn" style="margin-top: 10px;">
          <div>РЕКЛАМА</div>
          <div>Рекламодатель:</div>
          <div style="display: flex; align-items: center; justify-content: start; gap: 10px;">
           <span id="custom-field-name" data-field-name="name" data-field-type="text">${
             formValues.name || ''
           }</span>
            <div style="display: flex; align-items: center; justify-content: start; gap: 5px;">  
              <span>ИНН:</span>
              <span id="custom-field-inn" data-field-name="inn" data-field-type="text">${
                formValues.inn || ''
              }</span>
            </div>
          </div>
          <div>
            <span>ЕРИД:</span>
            <span id="custom-field-erid" data-field-name="erid" data-field-type="text">${
              formValues.erid || ''
            }</span>
          </div>
        </div>
      `
      : '';

  return (
    htmlContent +
    additionalFields
      .replace(/\n/g, '')
      .replace(/&nbsp;/g, ' ')
      .replace(/<p>\s*<\/p>/g, '')
      .replace(/<p>(<br\s*\/?>)*<\/p>/g, '')
  );
};

export const prepareFormValues = (formValues, editorState) => {
  return Object.entries(formValues).reduce((acc, [key, value]) => {
    if (key === filedNames.dateTime) {
      const [datePub, dateEnd] = value;
      acc.datePub = datePub.clone().utc().format();
      acc.dateEnd = dateEnd.clone().utc().format();
      return acc;
    }

    if (key === filedNames.text) {
      acc[key] = parseContent(
        formValues,
        stateToHTML(editorState.getCurrentContent())
      );
      return acc;
    }

    if (key === filedNames.title) {
      acc[key] = value.trim();
      return acc;
    }

    if (key === filedNames.files && value?.length > 0) {
      acc[key] = value.map((file) => file.originFileObj);
      return acc;
    }

    acc[key] = value;

    return acc;
  }, {});
};
